import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { Loader, Menu, Dropdown, Card, Table, Popup, Button } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';
import hasUserInfo from '../../hocs/has-user-info';


const countriesOptions = [
  { key: 'UK', value: 'UK', text: 'United Kingdom' },
  { key: 'US', value: 'US', text: 'United States' },
];


const currencies = {
  GBP: '£',
  USD: '$',
};

const getCurrencySymbol = currency => _.get(currencies, currency, '');

const getFixed = num => numeral(num).format('0.00');

const totalsRowStyles = {
  fontWeight: 900,
  backgroundColor: '#D2D1D7',
};

const OrdersTable = ({
  isLoading,
  orders,
  selectedCountry,
  onReload,
  isReloading,
  onCountrySelect }) => {
  const ordersTotals = _.sumBy(orders, 'orderTotal');
  const ordersCommissionsTotals = _.sumBy(orders, 'orderCommission');
  const orderCurrency = _.get(orders, '[0].orderCurrency');
  return (
    <div>
      <Menu icon>
        <Menu.Menu position="left">
          <Dropdown
            onChange={onCountrySelect}
            value={selectedCountry}
            options={countriesOptions}
            simple
            item
          />
        </Menu.Menu>
      </Menu>
      { isLoading && <Loader active content="Loading orders..." /> }


      <Card color="green" fluid>
        <Card.Content>
          {!isLoading &&
          <div style={{ display: 'flex', justifyContent: 'flex-between', alignItems: 'center' }}>
            <h3 style={{ flexGrow: 1 }}>Total Orders: {_.size(orders)}</h3>
            <Popup
              trigger={
                <Button
                  circular inverted color="green" icon="refresh"
                  onClick={() => (isReloading ? null : onReload(true))}
                  loading={isReloading}
                />
              }
              content="Click here reload orders"
            />
          </div>
          }
          { !isLoading &&
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell >
                      Order Date
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Order ID
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Campaign
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Term
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Name
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Discount Code
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Order Total
                </Table.HeaderCell>
                <Table.HeaderCell >
                      Order Commission
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                _.map(orders, order => <OrderTableRow
                  key={order.orderId}
                  order={order}
                />)
              }
            </Table.Body>
            <Table.Footer fullWidth>
              <Table.Row style={totalsRowStyles}>
                <Table.HeaderCell style={totalsRowStyles}>
                    TOTALS
                </Table.HeaderCell>
                <Table.HeaderCell style={totalsRowStyles} />
                <Table.HeaderCell style={totalsRowStyles} />
                <Table.HeaderCell style={totalsRowStyles} />
                <Table.HeaderCell style={totalsRowStyles} />
                <Table.HeaderCell style={totalsRowStyles} />
                <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                  {getCurrencySymbol(orderCurrency)}{getFixed(ordersTotals)}
                </Table.HeaderCell>
                <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                  {getCurrencySymbol(orderCurrency)}{getFixed(ordersCommissionsTotals)}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>}
          {
            isLoading && <p>Loading...</p>
          }
        </Card.Content>
      </Card>

    </div>
  );
};

const OrderTableRow = ({
  order,
}) => {
  const {
    orderDate,
    orderId,
    campaign,
    term,
    name,
    discountCode,
    orderTotal,
    orderCommission,
    orderCurrency,
  } = order;
  const date = orderDate ? moment(orderDate).format('YYYY-MM-DD, HH:mm') : null;
  return (
    <Table.Row>
      <Table.Cell>
        {date}
      </Table.Cell>
      <Table.Cell>
        {orderId}
      </Table.Cell>
      <Table.Cell>
        {campaign}
      </Table.Cell>
      <Table.Cell>
        {term}
      </Table.Cell>
      <Table.Cell>
        {name}
      </Table.Cell>
      <Table.Cell>
        {discountCode}
      </Table.Cell>
      <Table.Cell textAlign="right">
        {getCurrencySymbol(orderCurrency)}{getFixed(orderTotal)}
      </Table.Cell>
      <Table.Cell textAlign="right">
        {getCurrencySymbol(orderCurrency)}{getFixed(orderCommission)}
      </Table.Cell>
    </Table.Row>
  );
};

OrderTableRow.propTypes = {
  order: PropTypes.object.isRequired,
};

OrdersTable.propTypes = {
  onCountrySelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isReloading: PropTypes.bool,
  orders: PropTypes.array,
  selectedCountry: PropTypes.string,
  onReload: PropTypes.func,
};

OrdersTable.defaultProps = {
  isLoading: false,
  isReloading: false,
  orders: [],
  isLoadingCampaigns: false,
  isTimeoutError: false,
  selectedCountry: '',
  onReload: null,
};


export default compose(
  hasUserInfo,
)(OrdersTable);



/** WEBPACK FOOTER **
 ** ./src/containers/orders-table/index.js
 **/